//natives
import React from 'react';

import Alerta from "../../../../../../../util/snackbars/.mixins/";

//components
import Download from '../childrens/download/.mixins';
import ProtocolosLista from '../childrens/protocolosLista/.mixins';
import DatasLista from '../../DatasLista/.mixins';

//css
import css from '../../../.mixins/styles';
const useStyles = css();

export default (props) => {
    const classes = useStyles();
    
    return (
        <div>
            {!props.permissions['filtro-fornecedor'] &&
                <div>
                    {props.state.dataAgenda == null &&
                        <div className={'container'} align={'center'}>
                            <div className={classes.root} >
                                <DatasLista pai={props}/>
                                <br/>
                            </div>
                        </div>
                    }
                    {props.state.dataAgenda != null &&
                        <div>
                            <ProtocolosLista {...props}/>
                            <br/>
                        </div>
                    }
                </div>
            }
            <Download {...props}/>
            {props.permissions['filtro-fornecedor'] &&
                <ProtocolosLista {...props}/>
            }
            <Alerta ref={props.child}/>
        </div>
    );
};